import { apiGetOffers, apiGetOffer, apiGetSuggestedOffers, apiGetTrendingOffer, apiGetMore } from '../../api';
import * as types from '../mutation-types';

// Models
import PAGINATION from '@/store/models/pagination';
import OFFER from '@/store/models/offer';

// initial state
const state = {
  all: {
    data: [],
    meta: PAGINATION
  },

  single: OFFER,

  suggested: [],

  expiring: [],

  trending: {}
};

// mutations
const mutations = {
  [types.RECEIVED_OFFERS] (state, offers) {
    state.all.data = offers.data;
    state.all.meta = offers.meta;
  },

  [types.RECEIVED_OFFER] (state, offer) {
    state.single = offer;
  },

  [types.APPEND_OFFERS] (state, offers) {
    state.all.data = state.all.data.concat(offers.data);
    state.all.meta = offers.meta;
  },

  [types.RESET_OFFER] (state) {
    state.single = OFFER;
  },

  [types.RECEIVED_SUGGESTED_OFFERS] (state, offers) {
    state.suggested = offers;
  },

  [types.RECEIVED_EXPIRING_OFFERS] (state, offers) {
    state.expiring = offers;
  },

  [types.RECEIVED_TRENDING_OFFER] (state, offer) {
    state.trending = offer;
  }
};

const actions = {
  getAllOffers: ({ commit }) => {
    apiGetOffers()
      .then(({ data }) => {
        commit(types.RECEIVED_OFFERS, data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getMoreOffers: ({ commit }, url) => {
    return apiGetMore(url)
      .then(({ data }) => {
        commit(types.APPEND_OFFERS, data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getExpiringOffers: ({ commit }, limit = 3) => {
    apiGetOffers({ order: 'expires_at:asc', limit: limit })
      .then(({ data }) => {
        commit(types.RECEIVED_EXPIRING_OFFERS, data.data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getOffer: ({ commit }, slug) => {
    apiGetOffer(slug)
      .then(({ data }) => {
        commit(types.RECEIVED_OFFER, data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  resetOffer: ({ commit }) => {
    commit(types.RESET_OFFER);
  },

  getSuggestedOffers: ({ commit }) => {
    apiGetSuggestedOffers({ limit: 3 })
      .then(({ data }) => {
        commit(types.RECEIVED_SUGGESTED_OFFERS, data.data);
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getTrendingOffer: ({ commit }) => {
    apiGetTrendingOffer()
      .then(({ data }) => {
        commit(types.RECEIVED_TRENDING_OFFER, data);
      })
      .catch((error) => {
        console.log(error);
      })
  }
};

const getters = {
  offers (state) {
    return state;
  },

  offersSuggested (state) {
    return state.suggested;
  },

  offersExpiring (state) {
    return state.expiring;
  },

  offersTrending (state) {
    return state.trending;
  },

  offer (state) {
    return state.single;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/offers.js